module.exports = __webpack_public_path__ + "static/media/fullRoomTwo.614add91.png";